import { Fragment, useState } from "react";
import React from "react";
import {
  Dialog,
  Menu,
  Transition,
  Listbox,
  Disclosure,
} from "@headlessui/react";
import { Link, Navigate, useParams } from "react-router-dom";
import mainLogo from "../mglogo.png";
import {
  BellIcon,
  CalendarIcon,
  ChartBarIcon,
  FolderIcon,
  HomeIcon,
  InboxIcon,
  ShoppingBagIcon,
  MenuAlt2Icon,
  UsersIcon,
  ArchiveIcon,
  DocumentIcon,
  XIcon,
  ClipboardIcon,
  ShoppingCartIcon,
  TemplateIcon,
} from "@heroicons/react/outline";
import {
  CheckCircleIcon,
  SearchIcon,
  CheckIcon,
  SelectorIcon,
  ColorSwatchIcon,
  CogIcon,
} from "@heroicons/react/solid";
import axios from "axios";

const navigation = [
  {
    name: "Customer",
    href: "/crm/Customerlist",
    icon: UsersIcon,
    current: false,
  },
  {
    name: "Vendor",
    href: "/crm/Vendorslist",
    icon: FolderIcon,
    current: false,
  },
  {
    name: "Employee",
    href: "/crm/Employeelist",
    icon: UsersIcon,
    current: false,
  },
  {
    name: "Item",
    href: "/crm/Itemlist",
    icon: ShoppingBagIcon,
    current: false,
  },
  {
    name: "Invoice",
    href: "/crm/Invoicelist",
    icon: ShoppingCartIcon,
    current: false,
  },
  {
    name: "Purchase Order",
    href: "/crm/Purchaseorderlist",
    icon: ShoppingBagIcon,
    current: false,
  },
  { name: "Lead", href: "/crm/LeadList", icon: ClipboardIcon, current: false },
  {
    name: "Branch",
    href: "/crm/BranchList",
    icon: TemplateIcon,
    current: true,
  },
  {
    name: "Warehouse",
    href: "/crm/WarehouseList",
    icon: HomeIcon,
    current: false,
  },
  { name: "Bills", href: "/crm/Billslist", icon: DocumentIcon, current: false },
  {
    name: "Expense",
    href: "/crm/ExpenseList",
    icon: ColorSwatchIcon,
    current: false,
  },
  {
    name: "Inventory Transfer",
    href: "/crm/InventorytranferList",
    icon: ShoppingBagIcon,
    current: false,
  },
  {
    name: "Inventory Adjustments",
    href: "/crm/InventoryadjustmentsList",
    icon: ShoppingBagIcon,
    current: false,
  },
  {
    name: "Setting",
    current: false,
    icon: CogIcon,
    children: [
      { name: "Lead Source", href: "/crm/LeadsourceList" },
      { name: "Lead Status", href: "/crm/LeadstatusList" },
      { name: "Brand", href: "/crm/BrandList" },
      { name: "Manufacturer", href: "/crm/ManufacturersList" },
      { name: "Mode of Payment", href: "/crm/ModeofpaymentList" },
      { name: "Expense Category", href: "/crm/ExpensecateList" },
      { name: "Reason", href: "/crm/Reasonlist" },
    ],
  },
];
const userNavigation = [
  { name: "Organization Profile", href: "Organizationprofile" },
  { name: "Logout", href: "Login" },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

class BranchEditmodal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      sidebarOpen: false,
      setSidebarOpen: false,
      showmsg: false,
      logoutRedirect: false,
      success: false,
      redirect: false,
      name: "",
      street_one: "",
      street_two: "",
      city: "",
      editid: this.props.BranchId,
      state_union_territory_id: "",
      zip_postal_code: "",
      gstin: "",
      active_warehouse: [],
      branchList: [],
      branchstateList: [],
      error_list: [],
      loader: "",
      overLay: "",
    };
  }

  setLoaderFunction = (e) => {
    this.setState({ loader: "" });
    this.setState({
      overLay: "fixed inset-0 bg-black/30",
    });
  };
  closeLoaderFuncion = (e) => {
    this.setState({ loader: "" });
    this.setState({
      overLay: "",
    });
  };
  close = async (e) => {
    this.setState({ sidebarOpen: false });
  };
  open = async (e) => {
    console.log("open")
    this.setState({ sidebarOpen: true });
  };

  componentDidMount() {
    console.log("modalEdit");

    this.setLoaderFunction();
    const token = localStorage.getItem("token");

    //const { id } = this.props.params;
    const { id } = this.state.editid;
    const res1 = axios
      .get("public/api/branch/state/union/territory", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res1) => {
        this.setState({
          branchstateList: res1.data.branch_state_union_territory,
        });
      });

    const res2 = axios
      .get("public/api/branch/edit/" + this.state.editid, {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res2) => {
        this.setState({
          name: res2.data.branches.name,
          street_one: res2.data.branches.street_one,
          street_two: res2.data.branches.street_two,
          city: res2.data.branches.city,
          zip_postal_code: res2.data.branches.zip_postal_code,
          state_union_territory_id: res2.data.branches.state_union_territory_id,
          phone: res2.data.branches.phone,
          gstin: res2.data.branches.gstin,
        });
      });

    setTimeout(
      function () {
        //Start the timer
        this.closeLoaderFuncion();
        // this.setState({ loader: "" }); //After 1 second, set render to true
      }.bind(this),
      500
    );
  }

  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleEditudpateSuccess = (e) => {
    this.props.handleInputbranch(e);
  };

  updatebranch = async (e) => {
    this.setLoaderFunction();
    e.preventDefault();
    var token = localStorage.getItem("token");
    const headers = {
      authorization: `Bearer ${token}`,
      Accept: "application/json",
    };

    // const { id } = this.props.params;
    const res = await axios.post(
      "public/api/branch/update/" + this.state.editid,
      this.state,
      {
        headers,
      }
    );

    if (res.data.success) {
      this.setState({ showmsg: true });

      setTimeout(
        function () {
          //Start the timer
          this.closeLoaderFuncion();
          this.setState({ redirect: true }); //After 1 second, set render to true
        }.bind(this),
        1000
      );
    } else {
      this.closeLoaderFuncion();
      this.setState({ error_list: res.data.data });
      //this.setState({ show: true })
    }
    this.handleEditudpateSuccess(res.data.success);
  };

  //Logout function

  logout = async (e) => {
    e.preventDefault();
    var token = localStorage.getItem("token");

    const res = await axios.get("public/api/logout", {
      headers: {
        authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });

    //console.log(res);

    if (res.data.success) {
      localStorage.removeItem("token");

      //Start the timer
      this.setState({ logoutRedirect: true }); //After 1 second, set render to true
    }
  };

  //Logout function

  render() {
    let token = localStorage.getItem("token");

    if (token == null) {
      return <Navigate to={"/Login"} />;
    }

    if (this.state.logoutRedirect) {
      return <Navigate to={"/Login"} />;
    }

    if (this.state.redirect) {
      return <Navigate to={"/BranchList"} />;
    }

    return (
      <>
        {/*
        This example requires updating your template:

        ```
        <html class="h-full bg-gray-100">
        <body class="h-full">
        ```
      */}
        <div>
          <div className={this.state.overLay} aria-hidden="true" />

          {/* Static sidebar for desktop */}

          <div className="md: flex flex-col flex-1">
            <main className="flex-1 ">
              <div className="py-6">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
                  <h1 className="text-2xl font-semibold text-gray-900">
                    Update Branch
                  </h1>
                </div>
                <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
                  {/* Replace with your content */}

                  <div className="hidden sm:block" aria-hidden="true">
                    <div className="py-5">
                      <div className="border-t border-gray-200" />
                    </div>
                  </div>
                  <div className={`mt-10 sm:mt-0 ${this.state.loader}`}>
                    <div className="md:grid md:gap-6">
                      <div className="mt-5 md:mt-0 md:col-span-2">
                        <form onSubmit={this.updatebranch}>
                          <div className="shadow overflow-hidden sm:rounded-md">
                            <div className="px-4 py-5 bg-white sm:p-6">
                              <div className="grid grid-cols-6 gap-6">
                                <div className="col-span-6 sm:col-span-6 lg:col-span-3">
                                  <label
                                    htmlFor="name"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    {" "}
                                    <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                                      Branch Name
                                    </span>
                                  </label>
                                  <input
                                    type="text"
                                    name="name"
                                    id="name"
                                    onChange={this.handleInput}
                                    value={this.state.name}
                                    autoComplete="name"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="name-error"
                                  >
                                    {this.state.error_list.name}
                                  </p>
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-3">
                                  <label
                                    htmlFor="street_one"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Address Street 1
                                  </label>
                                  <input
                                    type="text"
                                    name="street_one"
                                    id="street_one"
                                    onChange={this.handleInput}
                                    value={this.state.street_one}
                                    autoComplete="street_one"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="street_one-error"
                                  >
                                    {this.state.error_list.street_one}
                                  </p>
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-3">
                                  <label
                                    htmlFor="street_two"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Address Street 2
                                  </label>
                                  <input
                                    type="text"
                                    name="street_two"
                                    id="street_two"
                                    onChange={this.handleInput}
                                    value={this.state.street_two}
                                    autoComplete="street_two"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="street_two-error"
                                  >
                                    {this.state.error_list.street_two}
                                  </p>
                                </div>

                                <div className="col-span-6 sm:col-span-6 lg:col-span-3">
                                  <label
                                    htmlFor="city"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    City
                                  </label>
                                  <input
                                    type="text"
                                    name="city"
                                    id="city"
                                    onChange={this.handleInput}
                                    value={this.state.city}
                                    autoComplete="city"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="city-error"
                                  >
                                    {this.state.error_list.city}
                                  </p>
                                </div>

                                <div className="col-span-6 sm:col-span-6 lg:col-span-3">
                                  <label
                                    htmlFor="state_union_territory_id"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    State
                                  </label>

                                  <select
                                    id="state_union_territory_id"
                                    name="state_union_territory_id"
                                    value={this.state.state_union_territory_id}
                                    onChange={this.handleInput}
                                    autoComplete="state_union_territory_id"
                                    className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  >
                                    <option value="">------</option>
                                    {this.state.branchstateList.map(
                                      (number) => (
                                        <option value={number.id}>
                                          {number.name}
                                        </option>
                                      )
                                    )}

                                    <p
                                      className="mt-2 text-sm text-red-600"
                                      id="state_union_territory_id-error"
                                    >
                                      {
                                        this.state.error_list
                                          .state_union_territory_id
                                      }
                                    </p>
                                  </select>
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-3">
                                  <label
                                    htmlFor="zip_postal_code"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Zip Code
                                  </label>
                                  <input
                                    type="text"
                                    name="zip_postal_code"
                                    id="zip_postal_code"
                                    onChange={this.handleInput}
                                    value={this.state.zip_postal_code}
                                    autoComplete="zip_postal_code"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="zip_postal_code-error"
                                  >
                                    {this.state.error_list.zip_postal_code}
                                  </p>
                                </div>

                                <div className="col-span-6 sm:col-span-6 lg:col-span-3">
                                  <label
                                    htmlFor="gstin"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                                      GSTIN
                                    </span>
                                  </label>
                                  <input
                                    type="text"
                                    name="gstin"
                                    id="gstin"
                                    onChange={this.handleInput}
                                    value={this.state.gstin}
                                    autoComplete="gstin"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="gstin-error"
                                  >
                                    {this.state.error_list.gstin}
                                  </p>
                                </div>
                              </div>
                            </div>

                            <div className="px-4 py-3 bg-gray-50 text-right sm:px-6">
                              <button
                                type="submit"
                                className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                              >
                                Save
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>

                  {/* /End replace */}
                </div>
              </div>
            </main>
          </div>
        </div>

        <div
          aria-live="assertive"
          className="fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start"
        >
          <div className="w-full flex flex-col items-center space-y-4 sm:items-end">
            {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
            <Transition
              show={this.state.showmsg}
              //show={true}
              as={Fragment}
              enter="transform ease-out duration-300 transition"
              enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
              enterTo="translate-y-0 opacity-100 sm:translate-x-0"
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 mt-10">
                <div className="p-4">
                  <div className="flex">
                    <div className="flex-shrink-0">
                      <CheckCircleIcon
                        className="h-6 w-6 text-green-400"
                        aria-hidden="true"
                      />
                    </div>
                    <div className="ml-3 w-0 flex-1 pt-0.5">
                      <p className="text-sm font-medium text-gray-900">
                        Successfully Updated
                      </p>
                      <p className="mt-1 text-sm text-gray-500"></p>
                    </div>
                    <div className="ml-4 flex-shrink-0 flex">
                      <button
                        className="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        onClick={() => {
                          this.setState({ showmsg: false });
                        }}
                      >
                        <span className="sr-only">Close</span>
                        <XIcon className="h-5 w-5" aria-hidden="true" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Transition>
          </div>
        </div>
      </>
    );
  }
}

export default (props) => <BranchEditmodal {...props} params={useParams()} />;
